/* Recently viewed products.
   The list of ids lives in localStorage; turning them back into cards means
   re-fetching this section through the search route with an `id:` query, which
   is the one route that renders arbitrary products server-side. */
(function () {
  var KEY = 'criniere:recently-viewed';
  var MAX_STORED = 20;

  function read() {
    try {
      var raw = window.localStorage.getItem(KEY);
      var list = raw ? JSON.parse(raw) : [];
      return Array.isArray(list) ? list : [];
    } catch (e) {
      // Private browsing and blocked storage both throw here.
      return [];
    }
  }

  function write(list) {
    try {
      window.localStorage.setItem(KEY, JSON.stringify(list));
    } catch (e) {
      /* nothing to do — the feature is a nicety, not a requirement */
    }
  }

  function init(root) {
    if (root.dataset.recentlyViewedReady === 'true') return;
    root.dataset.recentlyViewedReady = 'true';

    var current = root.dataset.currentId;
    var sectionId = root.dataset.sectionId;
    var limit = parseInt(root.dataset.limit, 10) || 4;

    var stored = read();

    // Record this product first, so the list is correct even if the fetch
    // below fails or there is nothing yet to show.
    if (current) {
      stored = [current].concat(stored.filter(function (id) { return id !== current; }));
      write(stored.slice(0, MAX_STORED));
    }

    var ids = stored.filter(function (id) { return id !== current; }).slice(0, limit);
    if (!ids.length) return;

    var query = ids.map(function (id) { return 'id:' + id; }).join(' OR ');
    var url =
      '/search?section_id=' + encodeURIComponent(sectionId) +
      '&type=product&q=' + encodeURIComponent(query);

    fetch(url)
      .then(function (response) {
        if (!response.ok) throw new Error(response.status);
        return response.text();
      })
      .then(function (html) {
        var fresh = new DOMParser()
          .parseFromString(html, 'text/html')
          .querySelector('[data-recently-viewed]');

        if (!fresh || !fresh.innerHTML.trim()) return;

        root.innerHTML = fresh.innerHTML;

        // innerHTML never runs scripts, so re-attach what the markup needs.
        fresh.querySelectorAll('script[src]').forEach(function (old) {
          var script = document.createElement('script');
          script.src = old.src;
          script.defer = true;
          document.body.appendChild(script);
        });
      })
      .catch(function () {});
  }

  document.querySelectorAll('[data-recently-viewed]').forEach(init);

  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-recently-viewed]').forEach(init);
  });
})();
